export function applyMessengerCustomStyles(options = {}) {
	const {
		primaryColor = '#155EEF',
		textColor = '#1d1d1f',
		backgroundColor = '#ffffff',
		theme = 'light',
	} = options;

	let styleElement = document.getElementById(
		'product7-messenger-custom-styles'
	);

	if (!styleElement) {
		styleElement = document.createElement('style');
		styleElement.id = 'product7-messenger-custom-styles';
		document.head.appendChild(styleElement);
	}

	const adjustColor = (hex, percent, alpha = 1) => {
		const normalized = String(hex || '').trim();
		if (!/^#?[0-9a-fA-F]{6}$/.test(normalized)) {
			return normalized || '#000000';
		}

		const num = parseInt(normalized.replace('#', ''), 16);
		const r = Math.max(0, Math.min(255, (num >> 16) + percent));
		const g = Math.max(0, Math.min(255, ((num >> 8) & 0x00ff) + percent));
		const b = Math.max(0, Math.min(255, (num & 0x0000ff) + percent));

		if (alpha < 1) {
			return `rgba(${r}, ${g}, ${b}, ${alpha})`;
		}

		return '#' + ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0');
	};

	const darkSurface = adjustColor(backgroundColor, 12);
	const darkSurfaceAlt = adjustColor(backgroundColor, 20);
	const darkBorder = adjustColor(backgroundColor, 34);

	styleElement.textContent = `
		#product7-messenger-widget {
			--color-primary: ${primaryColor} !important;
			--color-primary-hover: ${adjustColor(primaryColor, -10)} !important;
		}

		.messenger-launcher-btn {
			background: ${primaryColor} !important;
		}

		.messenger-launcher-btn:hover {
			box-shadow: 0 8px 24px ${adjustColor(primaryColor, 0, 0.3)} !important;
		}

		.sdk-btn-primary {
			background: ${primaryColor} !important;
			border-color: ${primaryColor} !important;
		}

		.sdk-btn-primary:hover {
			background: ${adjustColor(primaryColor, -10)} !important;
			border-color: ${adjustColor(primaryColor, -10)} !important;
		}

		.messenger-compose-send {
			background: ${primaryColor} !important;
		}

		.messenger-compose-send:hover:not(:disabled) {
			background: ${adjustColor(primaryColor, -10)} !important;
		}

		.messenger-nav-tab.active .messenger-nav-icon,
		.messenger-nav-tab.active .messenger-nav-label {
			color: ${primaryColor} !important;
		}

		.messenger-home-view::before {
			background: radial-gradient(circle, ${adjustColor(primaryColor, 0, 0.08)} 0%, transparent 70%) !important;
		}

		${
			backgroundColor !== '#ffffff'
				? `
		.messenger-panel-content {
			background: ${backgroundColor} !important;
		}
		`
				: ''
		}

		${
			textColor !== '#1d1d1f'
				? `
		.messenger-panel-content,
		.messenger-view {
			color: ${textColor} !important;
		}
		`
				: ''
		}

		${
			theme === 'dark'
				? `
		.messenger-widget.theme-dark .messenger-panel-content,
		.messenger-widget.theme-dark .messenger-home-view,
		.messenger-widget.theme-dark .messenger-nav,
		.messenger-widget.theme-dark .messenger-chat-compose,
		.messenger-widget.theme-dark .messenger-compose-attachments-preview,
		.messenger-widget.theme-dark .messenger-home-featured,
		.messenger-widget.theme-dark .messenger-chat-header {
			background: ${backgroundColor} !important;
			border-color: ${darkBorder} !important;
		}

		.messenger-widget.theme-dark .messenger-view,
		.messenger-widget.theme-dark .messenger-chat-title,
		.messenger-widget.theme-dark .messenger-home-greeting,
		.messenger-widget.theme-dark .messenger-home-question,
		.messenger-widget.theme-dark .messenger-home-featured-content h3,
		.messenger-widget.theme-dark .messenger-home-featured-content p,
		.messenger-widget.theme-dark .messenger-home-changelog-card-title,
		.messenger-widget.theme-dark .messenger-home-changelog-card-desc,
		.messenger-widget.theme-dark .messenger-conversation-title,
		.messenger-widget.theme-dark .messenger-article-title,
		.messenger-widget.theme-dark .messenger-compose-input,
		.messenger-widget.theme-dark .messenger-message-sender,
		.messenger-widget.theme-dark .messenger-message-time,
		.messenger-widget.theme-dark .messenger-nav-label {
			color: ${textColor} !important;
		}

		.messenger-widget.theme-dark .messenger-home-view {
			background: linear-gradient(180deg, ${adjustColor(backgroundColor, 10)} 0%, ${backgroundColor} 55%) !important;
		}

		.messenger-widget.theme-dark .messenger-home-view::before {
			background: radial-gradient(circle, ${adjustColor(primaryColor, 0, 0.12)} 0%, transparent 70%) !important;
		}

		.messenger-widget.theme-dark .messenger-home-message-btn,
		.messenger-widget.theme-dark .messenger-home-changelog-card,
		.messenger-widget.theme-dark .messenger-compose-input-wrapper,
		.messenger-widget.theme-dark .messenger-message-received .messenger-message-bubble,
		.messenger-widget.theme-dark .messenger-message-file,
		.messenger-widget.theme-dark .messenger-prechat-card,
		.messenger-widget.theme-dark .messenger-list-item,
		.messenger-widget.theme-dark .messenger-article-item {
			background: ${darkSurface} !important;
			border-color: ${darkBorder} !important;
		}

		.messenger-widget.theme-dark .messenger-home-message-btn:hover,
		.messenger-widget.theme-dark .messenger-home-changelog-card:hover,
		.messenger-widget.theme-dark .messenger-list-item:hover,
		.messenger-widget.theme-dark .messenger-article-item:hover {
			background: ${darkSurfaceAlt} !important;
		}

		.messenger-widget.theme-dark .messenger-message-own .messenger-message-bubble,
		.messenger-widget.theme-dark .messenger-compose-send,
		.messenger-widget.theme-dark .messenger-launcher-btn,
		.messenger-widget.theme-dark .messenger-nav-badge,
		.messenger-widget.theme-dark .messenger-launcher-badge,
		.messenger-widget.theme-dark .messenger-home-changelog-cover-text,
		.messenger-widget.theme-dark .messenger-attachment-remove {
			color: #FFFFFF !important;
		}
		`
				: ''
		}
	`;

	console.log('✅ Custom messenger styles applied:', { primaryColor, theme });
}

export function removeMessengerCustomStyles() {
	const styleElement = document.getElementById(
		'product7-messenger-custom-styles'
	);
	if (styleElement && styleElement.parentNode) {
		styleElement.parentNode.removeChild(styleElement);
	}
}
